import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "components/ui/card";
import { Users, TrendingUp, DollarSign } from "lucide-react";

const benefits = [
  {
    icon: Users,
    title: "Access to Capital",
    description:
      "Raise up to $1.5M from thousands of investors who believe in your vision.",
  },
  {
    icon: TrendingUp,
    title: "Build Brand Loyalty",
    description:
      "Turn your customers into shareholders and advocates for your business.",
  },
  {
    icon: DollarSign,
    title: "Marketing Exposure",
    description:
      "Get your company in front of thousands of potential investors and customers.",
  },
];

export function RaiseBenefitsSection() {
  return (
    <section className="py-16 sm:py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12 xl:px-16">
        <h2 className="mb-12 text-center text-3xl font-bold">
          Why Choose Equity Crowdfunding?
        </h2>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {benefits.map((benefit) => (
            <Card key={benefit.title} className="text-center">
              <CardHeader>
                <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-accent/10">
                  <benefit.icon className="h-6 w-6 text-accent" />
                </div>
                <CardTitle className="text-lg">{benefit.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription>{benefit.description}</CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
